import React, {Component} from 'react';
import { connect } from 'react-redux'
import {CardElement, CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';
import shortid from 'shortid'
import { reduxForm, change } from 'redux-form'

import Button from '../Button/Button.js'
import CustomField from '../CustomField/CustomField.js'
import Checkbox from '../Checkbox/Checkbox.js'

import { 
  tryToCreateEnterprise,
} from '../../actions/actions.export.js';

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      display_name: '',
      domain: '',
      name: '',
      cardHasIssue: true,
      idempotency_key: shortid.generate(),
      agree_check: false
    }

    this.submit = this.submit.bind(this);
    this.handleCardChange = this.handleCardChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async submit(ev) {

    if(ev) ev.preventDefault();

    let {token} = await this.props.stripe.createToken({name: this.state.name});

    this.handleSubmit(token)
  }

  handleCardChange(e){
    this.setState({
      cardHasIssue: e.error || e.empty || !e.complete // pass an issue if it's empty or has an error
    })
  }

  componentDidMount(){
    const { user, dispatch } = this.props;

    this.setState({
      idempotency_key: shortid.generate(),
      domain: user.email.split("@")[1]
    })
    console.log(this.state.domain);

    dispatch(change('CreateAnEnterpriseForm', 'domain', user.email.split("@")[1]));
  }

  componentWillReceiveProps(newProps){
    const { dispatch } = this.props;

    if(newProps.team.failedToCreateEnterprise !== this.state.lastFail){
      this.setState({
        lastFail: newProps.team.failedToCreateEnterprise,
        idempotency_key: shortid.generate()
      })
    }
  }


  handleSubmit(stripe_token){
    const {user} = this.props;

    this.props.dispatch(tryToCreateEnterprise({
      stripe_token: stripe_token,
      display_name: this.state.display_name,
      domain: this.state.domain,
      billing_email: user.email,
      idempotency_key: this.state.idempotency_key
    }))
  }


  render() {
    const { team } = this.props;

    let formDisabled = !this.state.name || this.state.cardHasIssue || this.state.disabled || !this.state.display_name || !this.state.agree_check;

    return (
      <div className="checkout">
        <form onSubmit={(e)=>{
          e.preventDefault()
          if(!formDisabled) this.submit(e);
        }}> 
          <div className="container">
            <div className="row justify-content-center row-mega-pad-bottom">
              <div className="col-md-4">
                <CustomField 
                  type="text"
                  name="display_name"
                  placeholder="Great Architects & Assoc"
                  label="Firm Name"
                  value={this.state.display_name}
                  description="You can change this later."
                  onChange={(e) => { this.setState({display_name: e}); }}
                  serverErrors={team.createEnterpriseForm.errors.display_name}
                  required={true}
                  maxLength={64}
                  focus
                />

                <CustomField 
                  type="text"
                  name="domain"
                  placeholder="yourcompany.com"
                  label="Enterprise Email Domain"
                  value={this.state.domain}
                  description="This has to match your account's email address."
                  serverErrors={team.createEnterpriseForm.errors.domain}
                  disabled={true}
                  required={true}
                  maxLength={64}
                />

                <div className="row-push-down">
                  <CustomField 
                    type="text"
                    name="name"
                    placeholder="Jane Doe"
                    label="Billing Contact"
                    value={this.state.name}
                    maxLength={64}
                    required={true}
                    onChange={(e) => {this.setState({name: e}); }}
                  />
                  <div className="stripe-form-element-wrapper">
                    <div className="stripe-form-label">Credit Card Info*</div>
                    <CardElement style={{base: {fontSize: '14px', color: '#070809', '::placeholder': {color: 'rgba(0,0,0,.4)'}}}} onChange={this.handleCardChange}/>
                    <div className="stripe-form-description">All payments are processed securly by <a href="https://stripe.com" target="_blank" rel="noreferrer">Stripe</a>.</div>
                  </div>

                </div>
                
               
              </div>
              <div className="col-md-8">
                <div className="col-themed col-themed-invisible">
                  <p>
                    Creating or joining an Enterprise will convert your existing account into a <span className="text-700">managed account</span>.
                  </p>
                  <p>
                    What does this mean for you?
                  </p>
                  <ul className="list-bulleted list-spaced">
                    <li><span className="fa-li"><i className="fas fa-angle-right"></i></span>Your existing patterns will be imported into the Enterprise.</li>
                    <li><span className="fa-li"><i className="fas fa-angle-right"></i></span>You will only be able to save future patterns within the Enterprise.</li>
                    <li><span className="fa-li"><i className="fas fa-angle-right"></i></span>You will not be able to join any Firms or other Enterpises.</li>
                    <li><span className="fa-li"><i className="fas fa-angle-right"></i></span>Your email address must match one of the Enterprise's configured domains.</li>
                  </ul>


                  <div className="agree-wrapper">
                    <div className="agree-check">
                      <Checkbox value={this.state.agree_check} onToggle={(e)=>{ this.setState({agree_check: e}) }}/>
                    </div>
                    <div className="agree-text">
                      I understand that my account will become a managed account.
                    </div>
                  </div>

                  <hr/>
                  
                  <p className="">
                    After 30 days your subscription <nobr>will begin automatically</nobr>.
                  </p>
                  <div className="flex-split row-push-down text-700">
                    <div>
                      Monthly cost after free trial:
                    </div>
                    <div className="bold-lead">
                       ${ this.props.price }/month
                    </div>
                  </div>

                  { 
                    (team.createEnterpriseForm.errors.card) && 
                    <p className="list-item text-danger text-center">
                      <i className="fas fa-exclamation-triangle"/> &nbsp;{ team.createEnterpriseForm.errors.card }
                    </p>
                  }
                  { 
                    (team.createEnterpriseForm.errors.form) && 
                    <p className="list-item text-danger text-center">
                      <i className="fas fa-exclamation-triangle"/> &nbsp;{ team.createEnterpriseForm.errors.form }
                    </p>
                  }
                  
                  <Button
                    block={true}
                    submit={true}
                    display={"Start 30 Day Free Trial"}
                    disabled={formDisabled}
                    thinking={team.tryingToCreateEnterprise}
                    succesful={team.successfullyCreatedEnterprise}
                    failed={team.failedToCreateEnterprise}
                    color="success"
                    size="large"/>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}


CheckoutForm = reduxForm({
  // a unique name for the form
  form: 'CreateAnEnterpriseForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(CheckoutForm)

CheckoutForm = connect((state, ownProps) => {
  const { user, team } = state;

  var initialValues = {
    display_name: ''
  };
  
  return {
    user,
    team,
    initialValues
  }
})(CheckoutForm);


export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// ./src/components/CreateAnEnterpriseSubscriptionCCForm/CheckoutForm.js